import { Fragment } from "react";

/* MUI */
import { Grid, Typography, Radio, RadioGroup, FormControlLabel } from '@material-ui/core';


const FormRadio = ({ value, label, ...otherProps }) => {

  return (
    <FormControlLabel
      value={value}
      label={label}
      control={
        <Radio
          color="primary"
          {...otherProps}
        />}
    />
  )
}

const FormInputRadio = ({ label, value, onChange, ariaLabel, options, ...otherProps }) => {

  return (
    <Fragment>
      <Grid item xs={4}>
        <Typography variant="h6">{label}</Typography>
      </Grid>

      <Grid item xs={7} align="left">
        <RadioGroup aria-label={ariaLabel} value={value} onChange={onChange} row>
          {options.length > 0 && options.map((option, index) => {
            return (
              <FormRadio {...option} {...otherProps} key={index} />
            )
          })}
        </RadioGroup>
      </Grid>
    </Fragment>
  )
}

export default FormInputRadio;